import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { IResponse } from '../../http/interfaces/response.interface';
import { InitializerService } from '../../initializer/initializer.service';
import { PrebootService } from '../../preboot-helper/services/preboot.service';
import { EXCO_PlacementClient, loadSDK } from '../../../../../../node_modules/@excojs/placement-sdk';

export interface IExcoData {
  Url: string;
  Guid: string;
  Id: string;
  ContainerId: string;
}

@Injectable({
    providedIn: 'root',
})
export class ExcoService {

  lastGuid: string = '';
  lastPath: string = '';
  placement: any;

  constructor(
    private router: Router,
    private httpSvc: HttpClient,
    @Inject(DOCUMENT) private readonly document: any,
    private initializer: InitializerService,
    private prebootSvc: PrebootService
  ) {}

  start() {
    let apiUrl = this.initializer.getAppConfigs().apiUrl;

    this.router.events.pipe(filter(e => e instanceof NavigationEnd),map((e) => (e as NavigationEnd).urlAfterRedirects.split('?')[0])).subscribe((path) =>
      {
        this.httpSvc.get<IResponse<IExcoData>>(`${apiUrl}/exco?routePageId=${path}`).subscribe((exco) =>
          {
            this.prebootSvc.transitionComplete.subscribe(v => {
              if (v) {
                if (exco?.Result) {
                  this.setExco(exco.Result, path);
                }
                else if (this.lastGuid) this.removeLastElement();
              }
            });
          });
      }
    );
  }

  async excoEx(placementId, target) {
    // await loadSDK('18fb9c43-f34e-46c9-a65d-5bd50a6d4caf');
    await loadSDK('db853b78-e071-40b7-8f10-08a516d06e28');

    // this.placement = new EXCO_PlacementClient(placementId);
    this.placement = new EXCO_PlacementClient('3dec9e87-cbaf-48fb-8dc5-d35ac1af9d89');

    let element;
    if (target) {
      element = this.document.getElementById(target);
    }

    await this.placement.mount(element);

    // await placement.subscribe()
  }

  async setExco(exco: IExcoData, path) {
    if (this.lastGuid == exco.Guid || this.lastPath == path) {
      return;
    }
    await this.removeLastElement();
    await this.excoEx(exco.Guid, exco.Id);
    this.lastGuid = exco.Guid;
    this.lastPath = path;
  }

  async removeLastElement() {
    if (this.lastGuid) {
      await this.placement.unmount();
    }
    this.lastGuid = '';
    this.lastPath = '';
  }
}
